export default function(x) {
  return function() {
    return x;
  };
}



//////////////////
// WEBPACK FOOTER
// /home/circleci/pickle/~/d3-geo/src/constant.js
// module id = HvtU
// module chunks = 0